import { PostHogProvider } from "posthog-js/react";
import type { ReactNode } from "react";

interface AnalyticsProviderProps {
  children: ReactNode;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

  // Throw an error if no API key is provided
  if (!apiKey) {
    throw new Error("VITE_PUBLIC_POSTHOG_KEY environment variable is required for analytics");
  }

  return (
    <PostHogProvider
      apiKey={apiKey}
      options={{
        api_host: "https://us.i.posthog.com",
        capture_exceptions: false,
        debug: import.meta.env.VITE_DEBUG === "true",
        capture_pageview: true,
        capture_pageleave: true,
        loaded: (posthog) => {
          posthog.register({
            $host: window.location.host,
            $origin: window.location.origin,
            $protocol: window.location.protocol,
          });
        },
      }}
    >
      {children}
    </PostHogProvider>
  );
}
